export default {
    ASC:  'ASC',
    DESC: 'DESC',
    NONE: 'NONE',
}
